import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { IRootThunkDispatch } from "../../redux/store";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { axiosGet } from "../../util/axios";
import { Grid } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { getCurrentDate } from "../../util/date";

function CollectionProgress() {
    const [collectionProgress, setCollectionProgress] = useState<any>([]);
    const [fontSize, setFontSize] = useState(30);
    const [FontSizeRange, _] = useState([
        '放大',
        '縮小'
    ]);
    const today = getCurrentDate();
    const dispatch = useDispatch<IRootThunkDispatch>();
    const dataFetchedRef = useRef(false);

    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        getCollectionProgressData();
        return () => {
            controller.abort();
        };
    }, []);

    async function getCollectionProgressData() {
        dispatch(OpenLoadingBarThunk(true));
        const result = await axiosGet("/api/collection/currentProgress");
        if (result.data.success) {
            dispatch(OpenLoadingBarThunk(false));
            setCollectionProgress(result.data.routeList);
        } else {
            alert("fail to fetch ");
        }
    }

    const columns: GridColDef[] = [
        {
            field: "route_name",
            headerName: "車線",
            width: 200,
            headerAlign: "center",
            renderCell: (data) => (
                <div style={{ fontSize: fontSize }}>{data.value}</div>
            ),
        },
        {
            field: "collected_point",
            headerName: "已收集",
            width: 100,
            headerAlign: "center",
            renderCell: (data) => (
                <div style={{ fontSize: fontSize }}>{data.value}</div>
            ),
        },
        {
            field: "collection_point",
            headerName: "數量",
            width: 100,
            headerAlign: "center",
            renderCell: (data) => (
                <div style={{ fontSize: fontSize }}>{data.value}</div>
            ),
        },
    ];

    function handleClickFontSize(font:string){


        if (font==='放大'){

            if (fontSize>50){
                alert('無法再放大了')
                return 
            }

            let newFont = fontSize+10
         
            setFontSize(newFont)
        }else{

            if (fontSize<30){
                alert('無法再縮小了')
                return 
            }

            let newFont = fontSize-10
            setFontSize(newFont)
        }
    }


    return (
        <>
      
            <Grid style={{ display: "flex" ,alignItems:'center',marginBottom:15}}>
            
                {FontSizeRange.map((font) => (
                    <Grid style={{ flex: "1" ,textAlign:'center'}} onClick={()=>handleClickFontSize(font)}>{font}</Grid>
                ))}
            </Grid>
            <Grid
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 28,
                    fontWeight: "bold",
                }}
            >
                <Grid>{today}工作進度</Grid>

                {collectionProgress ? (
                    <div style={{ height: "100%", width: "100%" }}>
                        <DataGrid
                            rows={collectionProgress || []}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 20 },
                                },
                            }}
                            pageSizeOptions={[5, 10]}
                            getRowId={(row) => row.route_id}
                            disableColumnMenu
                        />
                    </div>
                ) : (
                    <></>
                )}
            </Grid>
        </>
    );
}

export default CollectionProgress;
